import { render, staticRenderFns } from "./loggingMixin.vue?vue&type=template&id=4b5d635f&"
import script from "./loggingMixin.vue?vue&type=script&lang=js&"
export * from "./loggingMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports